import { AnyAction } from '@reduxjs/toolkit'
import { logger } from 'helpers/logger'

export const makeSerializable = (
  action: AnyAction,
): Record<string, unknown> => {
  try {
    const { type, payload, id } = action
    const serialized: Record<string, unknown> = { type }

    if (payload !== undefined) {
      serialized.payload = JSON.parse(JSON.stringify(payload))
    }

    if (id) {
      serialized.id = id
    }

    return serialized
  } catch (error) {
    logger.warn(`Could not serialize action type: ${action.type}`, error)
    return {
      type: action.type,
      payload: `[Non-serializable payload for action: ${action.type}]`,
    }
  }
}
